import { useSelector, useDispatch } from 'react-redux'
import {
  selectDarkTheme,
  selectColorScheme,
  setColorScheme,
  ColorSchemeType,
} from '../../store/slices/settingsSlice'
import { useEffect } from 'react'
import { getFromStorage, saveToStorage } from '../utils/functions/localStorage'

type Theme = 'light' | 'dark'

interface UseThemeReturn {
  theme: Theme
  isDark: boolean
  colorScheme: ColorSchemeType
  setColorScheme: (scheme: ColorSchemeType) => void
}

export const useTheme = (): UseThemeReturn => {
  const dispatch = useDispatch()
  const isDark = useSelector(selectDarkTheme)
  const colorScheme = useSelector(selectColorScheme)

  // Загрузка из localStorage при монтировании
  useEffect(() => {
    const saved = getFromStorage('colorScheme')
    if (saved) {
      dispatch(setColorScheme(saved as ColorSchemeType))
    }
  }, [])

  // Сохранение в localStorage при изменении
  useEffect(() => {
    saveToStorage('colorScheme', colorScheme)
  }, [colorScheme])

  // Применяем тему и цветовую схему к DOM
  useEffect(() => {
    document.documentElement.setAttribute('data-theme', isDark ? 'dark' : 'light')
    document.documentElement.setAttribute('data-color-scheme', colorScheme)
  }, [isDark, colorScheme])

  return {
    theme: isDark ? 'dark' : 'light',
    isDark,
    colorScheme,
    setColorScheme: (scheme: ColorSchemeType) => dispatch(setColorScheme(scheme)),
  }
}
